import { getAuthUserName } from './authToken';

// 无权限账号的用户名兜底名单（当后端未返回 role_id 时按账号名判断）
const NO_PERMISSION_USER_NAMES = ['user1'];

/**
 * 判断当前账号是否无权限（相当于 role 为 user）
 * 判断依据（任一命中即视为无权限）：
 * 1. userInfo.role_id === 'user'
 * 2. 登录用户名在兜底名单内（如 user1）
 * @param {object} userInfo redux 中的用户信息
 * @returns {boolean}
 */
export function isNoPermission(userInfo) {
    const roleId = userInfo && userInfo.role_id;
    if (roleId && String(roleId).trim() === 'user') {
        return true;
    }

    const userName = getAuthUserName();
    if (userName && NO_PERMISSION_USER_NAMES.indexOf(userName) >= 0) {
        return true;
    }

    return false;
}
